const de = {
	Credentials: "Zertifikate",
	Logout: "Ausloggen",
	"My Credentials": "Meine Zertifikate",
	"Issue Date": "Ausgabedatum",
	By: "Von",
	View: "Ansicht",
	Verify: "Überprüfen",
	purchase_for: "Kauf für ",
	"Terms of Service": "Nutzungsbedingungen",
	"Privacy & Data Protection": "Privatsphäre & Datenschutz",
	"Customer Support": "Kundendienst",
	"Help Center": "Hilfezentrum",
	"Verify Certificate": "Zertifikat überprüfen",
	"View Certificate": "Zertifikat ansehen",
	Inbox: "Posteingang",
	"Open Issuers App": "Emittenten-App",
	Name: "Name",
	"You are purchasing": "Sie kaufen",
	"Payment info": "Zahlungsinformationen",
	Email: "Email",
};
export default de;
